exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item[data-v-01af3108] {\n  color: #1e0080;\n  font-weight: bold;\n}\nhr[data-v-01af3108] {\n  border-color: #7da0b8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01af3108","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/PersonalDetails.vue
// module id = yPcn
// module chunks = 1